import mapKidsToRequest from './mappers/mapKidsToRequest'

export default function(api: GlobalFetch) {
  return async function(values, objectId, calendarId) {
    const requestBody = mapKidsToRequest(values, objectId, calendarId)
    const response = await api.fetch(
      `/api/v2/price/kids/id_calendar/${calendarId}/id_object/${objectId}/`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return response.status.toString()
    } else {
      throw new Error(response.status.toString())
    }
  }
}
